import { render } from "./CardVideo.vue?vue&type=template&id=d6130fde"
import script from "./CardVideo.vue?vue&type=script&lang=js"
export * from "./CardVideo.vue?vue&type=script&lang=js"
script.render = render

export default script